import scrollIntoView from 'scroll-into-view-if-needed';

const propelInit = function() {
class TabComponent {
	constructor(element) {
		this.tabBlock = element;

		this.tabButtons = Array.from(
			this.tabBlock.querySelectorAll('.block-tabs__button')
		);

		this.init();
	}

	init() {
		this.tabButtons.forEach((tabButton) => {
			const controlsId = tabButton.getAttribute('aria-controls');

			tabButton.targetTab = this.tabBlock.querySelector(`#${controlsId}`);
			tabButton.addEventListener('click', (e) => this.onTabClick(e));
			tabButton.addEventListener('keydown', (e) => this.onTabKeydown(e));

			tabButton.addEventListener('propel-dropdown-option-selected', (e) =>
				this.onTabClick(e)
			);

			if (tabButton.getAttribute('aria-selected') === 'true') {
				tabButton.removeAttribute('tabindex');
				tabButton.targetTab.removeAttribute('hidden');
			} else {
				tabButton.setAttribute('tabindex', '-1');
				tabButton.targetTab.setAttribute('hidden', '');
			}
		});

		this.openTabFromUrl();
	}

	openTabFromUrl() {
		const tabParam = new URLSearchParams(window.location.search).get('tab');

		if (!tabParam) {
			return;
		}

		const matchingTab = this.tabButtons.find(
			(tabButton) => tabButton.dataset.scrollId === tabParam
		);

		if (matchingTab) {
			this.switchTab(matchingTab, { setFocus: false, updateUrl: false });

			scrollIntoView(this.tabBlock, {
				scrollMode: 'if-needed',
				behavior: 'auto',
				block: 'start',
				inline: 'start',
			});
		}
	}

	switchTab(newSelectedTab, { setFocus = true, updateUrl = true } = {}) {
		this.tabButtons.forEach((tabButton) => {
			const targetPanel = tabButton.targetTab;

			if (tabButton === newSelectedTab) {
				tabButton.setAttribute('aria-selected', 'true');
				tabButton.removeAttribute('tabindex');
				targetPanel.removeAttribute('hidden');

				if (setFocus) {
					tabButton.focus();
				}
			} else {
				tabButton.setAttribute('aria-selected', 'false');
				tabButton.setAttribute('tabindex', '-1');
				targetPanel.setAttribute('hidden', '');
			}
		});

		if (updateUrl && newSelectedTab.dataset.scrollId) {
			const url = new URL(window.location.href);

			url.searchParams.set('tab', newSelectedTab.dataset.scrollId);
			window.history.replaceState(null, '', url);
		}

		newSelectedTab.dispatchEvent(
			new CustomEvent('propel-tab-changed', { bubbles: true })
		);
	}

	onTabClick(e) {
		e.preventDefault();
		this.switchTab(e.currentTarget);
	}

	onTabKeydown(e) {
		const currentTab = e.currentTarget;
		const currentIndex = this.tabButtons.indexOf(currentTab);
		let nextIndex = null;

		switch (e.key) {
			case 'ArrowLeft':
			case 'ArrowUp':
				nextIndex =
					currentIndex === 0
						? this.tabButtons.length - 1
						: currentIndex - 1;
				break;
			case 'ArrowRight':
			case 'ArrowDown':
				nextIndex =
					currentIndex === this.tabButtons.length - 1
						? 0
						: currentIndex + 1;
				break;
			case 'Home':
				nextIndex = 0;
				break;
			case 'End':
				nextIndex = this.tabButtons.length - 1;
				break;
			default:
				return;
		}

		if (nextIndex !== null) {
			e.preventDefault();
			this.switchTab(this.tabButtons[nextIndex]);
		}
	}
}

const tabBlocks = document.querySelectorAll('.block-tabs');
tabBlocks.forEach((block) => new TabComponent(block));

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['tabs'] = window.propel.blocks['tabs'] || {};
window.propel.blocks['tabs'].script = propelInit;
